// File: frontend/src/config/historyEvents.js
// Version: 1.0 (quick-260909-v7b)
// Date: 2026-09-09
// Назначение: ЕДИНСТВЕННЫЙ держатель типов событий на фронте — метка, значок,
//             класс отметки источника.
//
// 🔴 ТРИ ФАКТА, У КАЖДОГО СКАЗАНО, ЧЕМ ОН ПРОВЕРЕН.
//
// (а) «ВОПРОСЫ» И «РЕШЕНИЯ» ПОЯВИЛИСЬ 10.09.2026 — И ТОЛЬКО ПОТОМУ, ЧТО У НИХ
//     ЗАВЁЛСЯ ПИСАТЕЛЬ. Прежняя редакция этого файла говорила: «их здесь нет,
//     писателя нет ни у одного» — и это было верно ДО quick-260910-u2q.
//     Теперь писателей три и все названы: `ai_paralegal.question_consilium`
//     (вопрос), `email_triage.approve_email` и `case_deadlines.postavit_srok`
//     (решение). Что вызов писателя ЕСТЬ, а не обещан, доказывает разбором
//     `ast` сторож `verify_fitenko_razryady.py` (П1), а не этот комментарий.
//     🔴 Метка БЕЗ писателя по-прежнему запрещена: таблетка, которой нечем
//     наполниться, — украшение. И чипс всё равно появится не от метки, а от
//     первого настоящего события: список чипсов выводится ИЗ ЛЕНТЫ.
//
// (б) МЁРТВАЯ МЕТКА НАЗВАНА, А НЕ ОСТАВЛЕНА МОЛЧА. `checklist_verified` живёт в
//     старом компоненте `components/history/HistoryTimeline.js` с прежних
//     времён. Писателей по грепу всего репозитория (py + js, без node_modules):
//     0. В таблетках она НЕ УЧАСТВУЕТ — её нет в SOBYTIYA. Она нужна ровно
//     затем, чтобы отрисовка страницы `/leads/:id` не изменилась ни на символ
//     ни у fitenko, ни у MLG. Убирать её — отдельная задача с замером по боевой
//     базе; вынесена в `deferred-items.md` задачи v7b.
//
// (в) ПОРЯДОК И КЛЮЧИ ВЗЯТЫ У БЭКЕНДА. Ключи равны закрытому словарю
//     `ORIGIN_OF_EVENT` (backend/app/services/history/person_feed.py) и в том же
//     порядке. Равенство ключей и равенство РАЗБИЕНИЙ по источнику доказывают
//     ворота `slovar-ist.py` (С1, С2), а не этот комментарий. Метки — русские,
//     перенесены из прежнего `TYPE_LABEL` буква в букву; посимвольное равенство
//     на объединении ключей доказывает С3.
//
// 🔴 ЦВЕТА ЗДЕСЬ НЕ ЖИВУТ. Отметка красится классом `.fk-hist-mark--<mark>`,
//    цвет берётся из токена палитры. Ни одного hex в файле — храповик хардкода
//    не двигается (С4).

import {
    UserPlus,
    PhoneIncoming,
    MessageSquare,
    Mail,
    FileText,
    Briefcase,
    CheckSquare,
    CheckCircle2,
    Users,
    HelpCircle,
    Gavel,
} from 'lucide-react';

// 🔴 `mark` — КЛАСС ЭКВИВАЛЕНТНОСТИ, а не имя таблицы. Имён таблиц фронт не
//    знает и знать не должен: держатель источника один, и он на сервере. Два
//    типа делят отметку тогда и только тогда, когда делят строку-источник.
export const SOBYTIYA = {
    lead_created:      { label: 'Обращение',      icon: UserPlus,      mark: 'leads' },
    call_received:     { label: 'Звонок',         icon: PhoneIncoming, mark: 'calls' },
    sms_message:       { label: 'СМС',            icon: MessageSquare, mark: 'sms' },
    email_received:    { label: 'Письмо',         icon: Mail,          mark: 'emails' },
    document_uploaded: { label: 'Документ',       icon: FileText,      mark: 'docs' },
    case_created:      { label: 'Дело заведено',  icon: Briefcase,     mark: 'cases' },
    task_created:      { label: 'Задача',         icon: CheckSquare,   mark: 'tasks' },
    task_completed:    { label: 'Задача закрыта', icon: CheckCircle2,  mark: 'tasks' },
    team_assigned:     { label: 'Назначение',     icon: Users,         mark: 'none' },
    // 🔴 ДВА РАЗРЯДА quick-260910-u2q. У обоих есть НАЗВАННЫЙ писатель на
    //    сервере (`services/history/razryady.py`), иначе метка была бы
    //    украшением. `mark: 'none'` — источника нет по существу: учёт вопросов
    //    живёт в Redis, а у решения родов источника ДВА, и назвать один значило
    //    бы соврать про другой; прослеживаемость едет метаданными.
    question_asked:    { label: 'Вопрос',         icon: HelpCircle,    mark: 'none' },
    decision_made:     { label: 'Решение',        icon: Gavel,         mark: 'none' },
};

// 🔴 ЗАКРЫТЫЙ СЛОВАРЬ СОСТОЯНИЙ. Ключи — ТЕ ЖЕ, что у сервера
//    (`services/history/razryady.py::SOSTOYANIYA`); что множества совпадают,
//    доказывает СРАВНИВАЮЩАЯ под-проверка П8 сторожа `verify_fitenko_razryady`,
//    а не соседство двух списков в двух файлах.
//
// 🔴 СЛОВА ЗДЕСЬ ДРУГИЕ, И ЭТО НЕ РАСХОЖДЕНИЕ. Сервер словами называет
//    ПОСТУПОК и кладёт их в заголовок события («Срок поставлен»); здесь —
//    короткая метка РЕЗУЛЬТАТА рядом с разрядом. Две работы, один набор ключей.
export const SOSTOYANIYA = {
    izvesten:            'Срок есть',
    priznan_neizvestnym: 'Пока неизвестен',
    ne_sprashivali:      'Срок снят',
    pismo_otpravleno:    'Отправлено',
    vopros_v_ocheredi:   'В очереди',
};

// Сколько раз состояние оказалось вне словаря — тем же приёмом, что и типы.
let _neopoznannyhSostoyanij = 0;

export const schetNeopoznannyhSostoyanij = () => _neopoznannyhSostoyanij;

// Метка состояния. null означает «состояния у события НЕТ» — и это не
// «незнакомое»: карточка тогда не рисует ничего. Незнакомый ключ возвращается
// САМ СОБОЙ и СЧИТАЕТСЯ.
export const metkaSostoyaniya = (kluch) => {
    if (!kluch) return null;
    if (Object.prototype.hasOwnProperty.call(SOSTOYANIYA, kluch)) return SOSTOYANIYA[kluch];
    _neopoznannyhSostoyanij += 1;   // СОСТОЯНИЕ НЕ ОПОЗНАНО
    return kluch;
};

// Метки без писателей. НЕ участвуют в таблетках и в SOBYTIYA их нет: таблетка,
// которой нечем наполниться, — украшение. Но метка нужна старой странице,
// чтобы её отрисовка не изменилась. Смотри факт (б) выше.
export const MERTVYE_METKI = {
    checklist_verified: 'Сверка',
};

// 🔴 Сколько раз тип оказался вне словаря. Образец — `origin_unresolved` на
//    сервере: неизвестный тип даёт СЧЁТ, а не догадку. Ноль здесь означает
//    «все типы словарю известны», а не «мы не смотрели».
let _neopoznannyh = 0;

export const schetNeopoznannyh = () => _neopoznannyh;

// Известен ли тип — ЧИСТЫЙ предикат без побочного счёта. Экран считает
// неопознанные типы им: счётчик модуля растёт при каждой перерисовке и для
// показа на экране не годится.
export const izvestenTip = (tip) => Object.prototype.hasOwnProperty.call(SOBYTIYA, tip)
    || Object.prototype.hasOwnProperty.call(MERTVYE_METKI, tip);

// Метка типа. Неизвестный тип возвращается САМ СОБОЙ и увеличивает счётчик:
// правдоподобная подстановка была бы неотличима от настоящего опознания.
export const metkaTipa = (tip) => {
    const zapis = SOBYTIYA[tip];
    if (zapis) return zapis.label;
    if (Object.prototype.hasOwnProperty.call(MERTVYE_METKI, tip)) return MERTVYE_METKI[tip];
    _neopoznannyh += 1;   // ТИП НЕ ОПОЗНАН
    return tip;
};

// Класс отметки источника. null означает «отметки НЕТ»: и у типа вне словаря,
// и у `team_assigned`, у которого источника нет по существу.
export const otmetkaTipa = (tip) => {
    const zapis = SOBYTIYA[tip];
    if (!zapis || zapis.mark === 'none') return null;
    return zapis.mark;
};

// Значок типа. null — значка нет; компонент рисует карточку без него, а не
// подставляет чужой.
export const znachokTipa = (tip) => (SOBYTIYA[tip] ? SOBYTIYA[tip].icon : null);

// Разные типы, встретившиеся в ленте и словарю НЕ известные. Чистая функция:
// её ответ зависит только от ленты, а не от истории перерисовок.
export const neopoznannyeTipy = (sobytiya) => Array.from(new Set(
    (sobytiya || []).map((e) => e && e.event_type).filter((t) => t && !izvestenTip(t)),
));

export default SOBYTIYA;
